export default __webpack_public_path__ + "static/media/information--toll-station--g1.b1ef927a.png";